import { memo, useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/AddRounded';
import _map from 'lodash/map';
// Local files
import { Root, StyledList } from './List.styled';
import Item from './Item/Item';
import ListSkeleton from 'components/Common/Feedback/ListSkeleton/ListSkeleton';
import Search from 'components/Common/Search/Search';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useApp from 'hooks/useApp';
import useCustomSelector from 'hooks/useCustomSelector';
import useLocations from 'hooks/useLocations';
import { locationsSelectors } from 'features/locations'

const LocationsList = () => {
  const navigate = useNavigate();
  const { setLocationDrawer } = useApp();
  const { getLocations, clearLocalLocations, clearLocalActiveLocation } = useLocations();
  const { data, pagination } = useCustomSelector(locationsSelectors.getLocationsData)
  const fetching = useCustomSelector(locationsSelectors.locationsIsFetching)
  const [query, setQuery] = useState('');

  const fetchLocations = useCallback((offset, query) => {
    getLocations({ offset, query })
  }, [getLocations]);
  const handleScroll = ({ target: { scrollTop, scrollHeight, offsetHeight } }) => 
  scrollTop >= scrollHeight - offsetHeight && pagination.total_count > pagination.count + pagination.offset && !fetching && fetchLocations(pagination.limit + pagination.offset, query);
  const handleCloseActiveLocation = (e) => { 
    e.stopPropagation();
    clearLocalActiveLocation()
    navigate('/locations');
  };
  
  useEffect(() => {
    const timeout = setTimeout(() => {
      clearLocalLocations();
      fetchLocations(0, query);
    }, !!query ? 500 : 0);

    return () => {
      clearTimeout(timeout);
    } 
  }, [query, fetchLocations, clearLocalLocations]);
  useEffect(() => {
    return clearLocalLocations
  }, [clearLocalLocations]);

  return (
    <Root onClick={handleCloseActiveLocation}>
      <Box sx={{ display: 'flex', gap: '2px', alignItems: 'center', p: '12px 16px 8px' }}>
        <Search fullWidth value={query} onChange={setQuery} />
        <Button
          variant='contained'
          color='primary'
          sx={{ minWidth: 'unset', height: 30, width: 30, p: .5, borderRadius: '50%' }}
          onClick={() => setLocationDrawer({ open: true, edit: false })}
        >
         <AddIcon />
        </Button>
      </Box>
      <StyledList onScroll={handleScroll}>
        {_map(data, (m) => <Item key={m.id} {...m} />)}
        {fetching && <ListSkeleton />}
      </StyledList>
    </Root>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <LocationsList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);